import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {AcListComponent} from './ac-list.component';
import {AcProgressModule} from '../ac-progress/ac-progress.module';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        FormsModule,

        AcProgressModule,
        VirtualScrollerModule,
    ],
    declarations: [
        AcListComponent,
    ],
    entryComponents: [
        AcListComponent,
    ],
    exports: [
        AcListComponent,
    ]
})
export class AcListModule {
}
